// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hpohhogajwteaejeyoqo.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imhwb2hob2dhand0ZWFlamV5b3FvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1NTEzMDQsImV4cCI6MjA3MTEyNzMwNH0.QScnHf2FoHCkkay1BAKuH1amW8GgOTXnS9Pi5jonP1M";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});